// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";  // ← AJOUTER

const firebaseConfig = {
  apiKey: "AIzaSyCmbhON6f4QsP4D0xxmTHmBDlLKlCatTFM",
  authDomain: "hippolyteapp-22007.firebaseapp.com",
  projectId: "hippolyteapp-22007",
  storageBucket: "hippolyteapp-22007.firebasestorage.app",
  messagingSenderId: "1026205772969",
  appId: "1:1026205772969:web:5cc72ca9eb1c7b4fc80db8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);  // ← AJOUTER

export default app;